import { MetrikaKeyGoalValidationData, MetrikaSelectedKeyGoal } from '../typings/metrikaKeyGoals';

export const INIT_METRIKA_KEY_GOALS_EDITORS = 'INIT_METRIKA_KEY_GOALS_EDITORS';
export type INIT_METRIKA_KEY_GOALS_EDITORS = typeof INIT_METRIKA_KEY_GOALS_EDITORS;

export interface InitKeyGoalsEditorsItemData {
    editorId: string;
    savedValue: MetrikaSelectedKeyGoal[];
}

export interface InitMetrikaKeyGoalsEditorsAction {
    type: INIT_METRIKA_KEY_GOALS_EDITORS;
    editors: InitKeyGoalsEditorsItemData[];
}

export function initMetrikaKeyGoalsEditors(editors: InitKeyGoalsEditorsItemData[]): InitMetrikaKeyGoalsEditorsAction {
    return {
        type: INIT_METRIKA_KEY_GOALS_EDITORS,
        editors
    };
}

export const OPEN_METRIKA_KEY_GOALS_EDITOR = 'OPEN_METRIKA_KEY_GOALS_EDITOR';
export type OPEN_METRIKA_KEY_GOALS_EDITOR = typeof OPEN_METRIKA_KEY_GOALS_EDITOR;

export interface OpenMetrikaKeyGoalsEditorAction {
    type: OPEN_METRIKA_KEY_GOALS_EDITOR;
    editorId: string;
}

export function openMetrikaKeyGoalsEditor(editorId: string): OpenMetrikaKeyGoalsEditorAction {
    return {
        type: OPEN_METRIKA_KEY_GOALS_EDITOR,
        editorId
    };
}

export const CLOSE_METRIKA_KEY_GOALS_EDITOR = 'CLOSE_METRIKA_KEY_GOALS_EDITOR';
export type CLOSE_METRIKA_KEY_GOALS_EDITOR = typeof CLOSE_METRIKA_KEY_GOALS_EDITOR;

export interface CloseMetrikaKeyGoalsEditorAction {
    type: CLOSE_METRIKA_KEY_GOALS_EDITOR;
    editorId: string;
}

export function closeMetrikaKeyGoalsEditor(editorId: string): CloseMetrikaKeyGoalsEditorAction {
    return {
        type: CLOSE_METRIKA_KEY_GOALS_EDITOR,
        editorId
    };
}

export const RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS = 'RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS';
export type RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS = typeof RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS;

export interface ResetMetrikaKeyGoalsEditorErrorsAction {
    type: RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS;
    editorId: string;
}

export function resetMetrikaKeyGoalsEditorErrors(editorId: string): ResetMetrikaKeyGoalsEditorErrorsAction {
    return {
        type: RESET_METRIKA_KEY_GOALS_EDITOR_ERRORS,
        editorId
    };
}

export const RESET_METRIKA_KEY_GOALS_EDITOR = 'RESET_METRIKA_KEY_GOALS_EDITOR';
export type RESET_METRIKA_KEY_GOALS_EDITOR = typeof RESET_METRIKA_KEY_GOALS_EDITOR;

export interface ResetMetrikaKeyGoalsEditorAction {
    type: RESET_METRIKA_KEY_GOALS_EDITOR;
    editorId: string;
    savedValue: MetrikaSelectedKeyGoal[];
}

export function resetMetrikaKeyGoalsEditor(
    editorId: string,
    savedValue: MetrikaSelectedKeyGoal[]
): ResetMetrikaKeyGoalsEditorAction {
    return {
        type: RESET_METRIKA_KEY_GOALS_EDITOR,
        editorId,
        savedValue
    };
}

export const SELECT_METRIKA_KEY_GOAL = 'SELECT_METRIKA_KEY_GOAL';
export type SELECT_METRIKA_KEY_GOAL = typeof SELECT_METRIKA_KEY_GOAL;

export interface SelectMetrikaKeyGoalAction {
    type: SELECT_METRIKA_KEY_GOAL;
    editorId: string;
    selectedGoalIndex: number;
    goalId: string;
    involvedSessionsId: string;
}

export function selectMetrikaKeyGoal(
    editorId: string,
    selectedGoalIndex: number,
    goalId: string,
    involvedSessionsId: string
): SelectMetrikaKeyGoalAction {
    return {
        type: SELECT_METRIKA_KEY_GOAL,
        editorId,
        selectedGoalIndex,
        goalId,
        involvedSessionsId
    };
}

export const ADD_METRIKA_KEY_GOAL = 'ADD_METRIKA_KEY_GOAL';
export type ADD_METRIKA_KEY_GOAL = typeof ADD_METRIKA_KEY_GOAL;

export interface AddMetrikaKeyGoalAction {
    type: ADD_METRIKA_KEY_GOAL;
    editorId: string;
    minConversion: number;
}

export function addMetrikaKeyGoal(editorId: string, minConversion: number): AddMetrikaKeyGoalAction {
    return {
        type: ADD_METRIKA_KEY_GOAL,
        editorId,
        minConversion
    };
}

export const DELETE_METRIKA_KEY_GOAL = 'DELETE_METRIKA_KEY_GOAL';
export type DELETE_METRIKA_KEY_GOAL = typeof DELETE_METRIKA_KEY_GOAL;

export interface DeleteMetrikaKeyGoalAction {
    type: DELETE_METRIKA_KEY_GOAL;
    editorId: string;
    goalIndex: number;
    involvedSessionsId: string;
}

export function deleteMetrikaKeyGoal(
    editorId: string,
    goalIndex: number,
    involvedSessionsId: string
): DeleteMetrikaKeyGoalAction {
    return {
        type: DELETE_METRIKA_KEY_GOAL,
        editorId,
        goalIndex,
        involvedSessionsId
    };
}

export const VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE = 'VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE';
export type VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE = typeof VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE;

export interface ValidateMetrikaKeyGoalConversionValue {
    type: VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE;
    editorId: string;
    selectedGoalIndex: number;
    conversionValue: string;
    involvedSessionsId: string;
}

export function validateMetrikaKeyGoalConversionValue(
    editorId: string,
    selectedGoalIndex: number,
    conversionValue: string,
    involvedSessionsId: string
): ValidateMetrikaKeyGoalConversionValue {
    return {
        type: VALIDATE_METRIKA_KEY_GOAL_CONVERSION_VALUE,
        editorId,
        selectedGoalIndex,
        conversionValue,
        involvedSessionsId
    };
}

export const SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS = 'SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS';
export type SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS = typeof SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS;

export interface ShowMetrikaKeyGoalsEditorErrorsAction {
    type: SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS;
    editorId: string;
    validationErrors: Record<string, MetrikaKeyGoalValidationData>;
}

export function showMetrikaKeyGoalsEditorErrors(
    editorId: string,
    validationErrors: Record<string, MetrikaKeyGoalValidationData>
): ShowMetrikaKeyGoalsEditorErrorsAction {
    return {
        type: SHOW_METRIKA_KEY_GOALS_EDITOR_ERRORS,
        editorId,
        validationErrors
    };
}

export const SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE =
    'SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE';
export type SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE = typeof SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE;

export interface ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable {
    type: SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE;
    editorId: string;
}

export function showMetrikaKeyGoalsEditorMetrikaIsUnavailable(
    editorId: string
): ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable {
    return {
        type: SHOW_METRIKA_KEY_GOALS_EDITOR_METRIKA_IS_UNAVAILABLE,
        editorId
    };
}

export type MetrikaKeyGoalsEditorAction =
    | OpenMetrikaKeyGoalsEditorAction
    | CloseMetrikaKeyGoalsEditorAction
    | SelectMetrikaKeyGoalAction
    | AddMetrikaKeyGoalAction
    | DeleteMetrikaKeyGoalAction
    | ValidateMetrikaKeyGoalConversionValue
    | ShowMetrikaKeyGoalsEditorErrorsAction
    | ShowMetrikaKeyGoalsEditorMetrikaIsUnavailable
    | InitMetrikaKeyGoalsEditorsAction
    | ResetMetrikaKeyGoalsEditorAction
    | ResetMetrikaKeyGoalsEditorErrorsAction;
